import React from 'react';
import './App.css';
import FirstScreen from './components/FirstScreen';
import SecondScreen from './components/SecondScreen';
import ThirdScreen from './components/ThirdScreen'; 
import MobileScreen from './components/MobileScreen';


const App = () => {
  return (
    <div className="App">  
      <div className='Content'>
        <MobileScreen />
        <section className="screen first-screen">
          {FirstScreen()}
        </section>
        <section id="secondScreen" className="screen second-screen">
          {SecondScreen()}
        </section>
        <section id="thirdScreen" className="screen third-screen">
          {ThirdScreen()}
        </section>
      </div>
    </div>
  );
}

export default App;
